import React, {useEffect, useState} from "react";
import {SubmitHandler, useForm} from "react-hook-form";
import {ModalInnerConfirmType} from "../interface";
import {useModal} from "../../../../hooks";
import PaginationSub from "../../pagination/PaginationSub";
import {BasicSearchType} from "../../../../types/common/basic";
import {useReadUserAccount} from "../hooks/useReadUserAccount";
import {useReadUserAccountDetail} from "../hooks/useReadUserAccountDetail";
import EmptyTableRow from "../../../../pages/common/EmptyTableRow";

interface UserInterface {
    userId: number;
    loginId: string;
    contactNo: string;
    crmId: string;
    password: string | null;
    userName: string;
    title: string;
    phoneNo: string;
    extensionNo: string;
    companyId: string;
    companyName: string;
    coEmail: string;
    remark: string;
    departmentId: string;
    departmentName: string;
    teamId: string;
    teamName: string;
    positionId: number;
    dutyGroupId: number;
    modAt: string;
    regAt: string;
    deleteFlag: string;
    dutyGroupName: string;
    roleName: string;
    dutyGroupTypeName: string;
    orgName: string;
    inOutFlag: number;
}


const userInit: UserInterface = {
    userId: 0,
    loginId: "",
    contactNo: "",
    crmId: "",
    password: null,
    userName: "",
    title: "",
    phoneNo: "",
    extensionNo: "",
    companyId: "",
    companyName: "",
    coEmail: "",
    remark: "",
    departmentId: "",
    departmentName: "",
    teamId: "",
    teamName: "",
    positionId: 0,
    dutyGroupId: 0,
    modAt: "",
    regAt: "",
    deleteFlag: "",
    dutyGroupName: "",
    roleName: "",
    dutyGroupTypeName: "",
    orgName: "",
    inOutFlag: 0,
}

/**
 * 주소 검색 모달
 * @param props
 * @returns
 */
const SearchUserInner = ({
                             confirmCallback,
                             cancelCallback,
                             modalDepth
                         }: ModalInnerConfirmType<UserInterface>) => {
    const {handleModal, resetModal} = useModal();

    const [searchOption, setSearchOption] =
        useState<BasicSearchType>({limit: 10, pageNo: 1, keywordType: "0", keyword: ""});

    const [clickedId, setClickedId] = useState<number>(0)
    const [selectedUser, setSelectedUser] = useState<UserInterface>(userInit)

    const {data: accountListMap} = useReadUserAccount(searchOption);
    const {data: accountDetail} = useReadUserAccountDetail(clickedId)

    const {register, handleSubmit} = useForm({
        defaultValues: searchOption,
    });

    const onSubmit: SubmitHandler<any> = (submitData) => {
        setSearchOption(submitData);
    };

    const onClose = () => {
        resetModal(modalDepth)
    }

    const onConfirm = () => {
        if (selectedUser.userId !== 0) {
            confirmCallback(selectedUser);
            onClose()
        } else {
            handleModal({
                isOpen: true,
                contents: "사용자를 선택해주세요.",
                type: "alert",
                depth: modalDepth + 1
            })
        }
    }

    const onCancel = () => {
        onClose()
        cancelCallback && cancelCallback()
    }

    const userList = accountListMap?.userList ?? []
    const totalCount = accountListMap?.totalCount ?? 0

    useEffect(() => {
        if (accountDetail) {
            setSelectedUser(accountDetail)
        }
    }, [accountDetail]);

    return (
        <>
            <form className="d-flex mb-15px" onSubmit={handleSubmit(onSubmit)}>
                <select className="form-select w-120px" {...register("keywordType")}>
                    <option value={'0'}>전체</option>
                    <option value={'1'}>이름</option>
                    <option value={'2'}>ID</option>
                    <option value={'3'}>회사명</option>
                </select>
                <input
                    type="text"
                    className="form-control w-250px ms-5px h-34px"
                    {...register("keyword")}
                />
                <button type="submit" className="btn btn-info btn_search w-80px ms-5px">
                    <img
                        src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                        alt=""
                    />
                    조회
                </button>
            </form>

            <table className="table table-bordered my_table">
                <thead>
                <tr>
                    <th style={{width: "4.4%"}}></th>
                    <th>ID</th>
                    <th>이름</th>
                    <th>직함</th>
                    <th>회사명</th>
                    <th>부서</th>
                    <th>팀</th>
                    <th>구분</th>
                    <th>조직</th>
                    <th>역할</th>
                </tr>
                </thead>
                <tbody>
                {userList && userList.length > 0 ? (
                    userList.map((item: any) => (
                        <tr key={item.userId}
                            className={`clickable ${item.userId === clickedId ? "lightblue" : ""}`}
                            onClick={() => setClickedId(item.userId)}>
                            <td className="text-center" style={{width: "4.4%"}}>
                                <div className="checkbox_outer">
                                    <input type="radio"
                                           className="form-check-input"
                                           checked={item.userId === clickedId}
                                           onClick={() => setClickedId(item.userId)}/>
                                </div>
                            </td>
                            <td>{item.loginId}</td>
                            <td className="text-center">{item.userName}</td>
                            <td className="text-center" style={{width: "100px"}}>{item.title || "-"}</td>
                            <td>{item.companyName}</td>
                            <td>{item.departmentName}</td>
                            <td>{item.teamName}</td>
                            <td className="text-center" style={{width: "100px"}}>{item.dutyGroupTypeName}</td>
                            <td className="text-center" style={{width: "100px"}}>{item.orgName}</td>
                            <td className="text-center" style={{width: "100px"}}>{item.roleName}</td>
                        </tr>
                    ))
                ) : (
                    <EmptyTableRow colSpan={11}/>
                )}
                </tbody>
            </table>

            <PaginationSub totalCount={totalCount}
                           currentPage={searchOption.pageNo}
                           onChangeCallback={(i) => setSearchOption({...searchOption, pageNo: i})}/>

            <div className="mt-3 d-flex align-items-center justify-content-end">
                <button
                    type="button"
                    className="btn btn-outline-primary w-100px h-38px my-0"
                    onClick={onCancel}
                >
                    취소
                </button>
                <button
                    type="button"
                    className="btn btn-dark w-100px h-38px my-0 ms-3"
                    onClick={onConfirm}
                >
                    선택
                </button>
            </div>
        </>
    );
};

export default SearchUserInner;
